import type { PropType } from 'vue';
import type { TLinkProps } from './TLink.types';
import { Icon } from '@iconify/vue';
import { merge } from 'es-toolkit/compat';
import { computed, defineComponent } from 'vue';
import { useTheme } from '../../composables/theme';
import { useStyles } from './TLink.styles';

const defaultProps = {
  variant: 'primary',
  size: 'medium',
};

export const TLink = defineComponent({
  name: 'TButton',
  props: {
    variant: String as PropType<TLinkProps['variant']>,
    size: String as PropType<TLinkProps['size']>,
    href: String as PropType<TLinkProps['href']>,
    leftIcon: String as PropType<TLinkProps['leftIcon']>,
    rightIcon: String as PropType<TLinkProps['leftIcon']>,
  },
  setup(_props, { attrs, slots }) {
    const props = computed(() => merge({}, defaultProps, _props, attrs));
    const baseClass = useStyles();
    const theme = useTheme();
    const classes = computed(() => [
      baseClass.value,
      `${baseClass.value}--${props.value.variant}`,
      `${baseClass.value}--${props.value.size}`,
    ]);
    return () => (
      <a class={classes.value} href={props.value.href} {...attrs}>
        {props.value.leftIcon
          ? (
              <Icon icon={`${theme.value.iconSet}:${props.value.leftIcon}`} />
            )
          : null}
        {slots.default ? slots.default() : null}
        {props.value.rightIcon
          ? (
              <Icon icon={`${theme.value.iconSet}:${props.value.rightIcon}`} />
            )
          : null}
      </a>
    );
  },
});
